import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import {
  DirectorConnectionService,
  DirectorConnectionState
} from './director-connection.service';

@Injectable()
/**
 * Guard that makes sure we know
 * the definitive status of Director.
 * More permissive than DirectorConnectedGuard
 * so we may guard routes while the
 * system is down, but still permit
 * routes that don't require director.
 * Appropriate for routes that only
 * require the reduced "Mini-Broker"
 * functionality.
 */
export class DirectorReadyGuard implements CanActivate, CanActivateChild {

  private _status: Observable<string>;

  constructor(
    private _store: Store<{ directorConnection: DirectorConnectionState }>,
    private _service: DirectorConnectionService
  ) {
    this._status = this._store.select(s => s.directorConnection.director)
      // Don't resolve until we get _something_ back from
      // the service so we can route immediately
      .filter(d => d !== undefined);
  }

  canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return this._status.map(s => s == 'connected' || s == 'disabled');
  }

  canActivateChild = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return this.canActivate(childRoute, state);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/director-connection/director-ready.guard.ts